export default "__VITE_PUBLIC_ASSET__3f1a8de3__"